import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import {
  createEditAction,
  createViewAction,
  formatCurrency,
  formatDateTime,
  getForm,
} from "../../utils/helpers";
import { URL_LIQUIDATION_CONFIGURABLES } from "../../utils/urls";

const url = URL_LIQUIDATION_CONFIGURABLES;

// REGISTER
export const useLiquidationsConfigurables = () => {
  const tableColumns = () => [
    {
      id: "collection_merchant_name",
      header: "Collection Merchant",
      filter: {},
    },
    {
      id: "liquidation_merchant_name",
      header: "Liquidation Merchant",
      filter: {},
    },
    {
      id: "floor_threshold_amount",
      header: "floor Threshold Amount",
      filter: {},
    },
    {
      id: "ceiling_threshold_amount",
      header: "Ceiling Threshold Amount",
      filter: {},
    },
    { id: "duration_unit", header: "Duration Unit", filter: {} },
    { id: "duration", header: "Duration", filter: {} },
    { id: "is_active", header: "Is Active", filter: {} },
    { id: "created_at", header: "Created At", filter: {} },
    { id: "actions", header: "Actions" },
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        is_active: <BooleanTags status={item?.is_active} />,
        floor_threshold_amount: formatCurrency(item?.floor_threshold_amount),
        ceiling_threshold_amount: formatCurrency(
          item?.ceiling_threshold_amount,
        ),
        created_at: formatDateTime(item?.created_at),
        actions: (
          <FormActions
            actions={[
              createEditAction(url, item?.id),
              createViewAction(url, item?.id),
            ]}
          />
        ),
      };
    }),
  ];
  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Liquidations Details",
          fields: {
            collection_merchant: item?.collection_merchant_name,
            liquidation_merchant: item?.liquidation_merchant_name,
            floor_threshold_amount: formatCurrency(
              item?.floor_threshold_amount,
            ),
            ceiling_threshold_amount: formatCurrency(
              item?.ceiling_threshold_amount,
            ),
            is_active: <BooleanTags status={item?.is_active} />,
            duration_unit: item?.duration_unit,
            duration: item?.duration,
            created_at: formatDateTime(item?.created_at),
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);

  return { tableData, tableColumns, formRoute, viewData };
};
